import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const FranchiseAccountingProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `FranchiseAccounting/${props.franchiseProductId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `FranchiseAccounting/Franchise/${props.franchiseId}`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `FranchiseAccounting/${props.franchiseProductId}`, method: 'PUT', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `FranchiseTransactionFees/GetItemsForNetsuiteMapping/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]); 
    
    const createNSRecord = useCallback(async (props) => {
        await execute({ scope: 'create_netsuitemapping', url: `FranchiseTransactionFees/SetItemForNetsuiteMapping/`, method: 'POST', payload: props, secure: true });
    }, [execute]); 

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `FranchiseAccounting/${props.franchiseProductId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, newRecord, deleteRecord, updateRecord, createRecord, createNSRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useFranchiseAccountingStore = () => React.useContext(Context);
